import React, { useCallback } from 'react';

import { SUBCATEGORIES } from '../../common/categories';
import * as actions from '../../containers/Security/securityActions';
import ArrayContainer from '../Controls/ArrayContainer/ArrayContainer';
import Button from '../Controls/Button/Button';
import SecurityRole from './SecurityRole';

const { ADMIN_SECURITY_ROLES } = SUBCATEGORIES;

const SecurityRoles = ({ fields, dispatch }) => {
    const securityRoles = fields[ADMIN_SECURITY_ROLES.ID];

    const dispatchUpdate = useCallback(
        (index, fieldId, value) => {
            dispatch({
                type: actions.UPDATE_SECURITY_ROLE,
                payload: { fieldId: ADMIN_SECURITY_ROLES.ID, index, arrFieldId: fieldId, value }
            });
        },
        [dispatch]
    );

    const dispatchRemove = useCallback(
        (index) => {
            dispatch({ type: actions.REMOVE_SECURITY_ROLE, payload: index });
        },
        [dispatch]
    );

    const dispatchAdd = useCallback(() => {
        dispatch({ type: actions.ADD_SECURITY_ROLE });
    }, [dispatch]);

    return (
        <>
            {securityRoles.value.map((role, index) => {
                return (
                    <ArrayContainer
                        key={ADMIN_SECURITY_ROLES.ID + index}
                        header="Security Role"
                        remove={() => dispatchRemove(index)}>
                        <SecurityRole role={role} changedFunc={(fId, v) => dispatchUpdate(index, fId, v)} />
                    </ArrayContainer>
                );
            })}

            <Button style={{ marginTop: `${securityRoles.value.length === 0 ? '30px' : '0'}` }} onClick={dispatchAdd}>
                + Add Security Role
            </Button>
        </>
    );
};

export default React.memo(SecurityRoles);
